
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 19 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 0L5.752 4.46H8.19v1.56H1.17v1.17H0v10.14h16.77v-1.17h1.56V6.02h-7.02V4.46h2.437L9.75 0zM4.12 6.8h11.26c.388 0 .524.215.72.67.078.185.151.36.28.488.147.148.37.23.597.317.315.12.572.236.572.378v4.875c0 .054-.004.065-.048.11-.023.022-.064.045-.11.072-.006.003-.006.01-.012.013a1.878 1.878 0 01-.146.073 8.974 8.974 0 01-.403.17c-.06.025-.126.046-.182.074-.014.006-.023.016-.037.024-.012.006-.024.017-.037.024-.064.035-.132.072-.195.134v.013c-.029.03-.06.062-.085.097-.08.105-.126.215-.17.317-.01.02-.016.04-.025.06-.049.115-.088.21-.134.293-.006.012-.018.026-.024.037a1.521 1.521 0 01-.098.146c-.009.01-.015.027-.024.037-.006.006-.019.006-.025.012a.494.494 0 01-.158.11c-.012.004-.023.009-.037.012-.026.007-.056.007-.085.012a.855.855 0 01-.134.012H4.12c-.39 0-.525-.216-.72-.67-.079-.185-.152-.36-.28-.488-.148-.147-.37-.23-.597-.317-.316-.12-.573-.236-.573-.377V8.653c0-.142.257-.258.573-.378.227-.087.45-.17.597-.317.128-.128.201-.303.28-.487.195-.456.33-.67.72-.67zm5.63.39c-1.935 0-3.51 1.75-3.51 3.9 0 2.151 1.575 3.9 3.51 3.9 1.934 0 3.51-1.749 3.51-3.9 0-2.15-1.576-3.9-3.51-3.9zm-8.97.78h.39v8.19h14.82v.39H.78V7.97zm3.315 1.95a.976.976 0 000 1.95.976.976 0 000-1.95zm11.31 0a.976.976 0 000 1.95.976.976 0 000-1.95z"}})])
          )
        }
      }
    